module.exports = __webpack_public_path__ + "static/media/ic_removeElement.4be36130.svg";